export default "__VITE_ASSET__4b30acb1__"